import { render, staticRenderFns } from "./PUCStopwatch.vue?vue&type=template&id=067e530e&scoped=true&"
import script from "./PUCStopwatch.vue?vue&type=script&lang=js&"
export * from "./PUCStopwatch.vue?vue&type=script&lang=js&"
import style0 from "./PUCStopwatch.vue?vue&type=style&index=0&id=067e530e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067e530e",
  null
  
)

export default component.exports